import ProgramsCards from '../programs/overview/Cards'
import { Box } from '@mui/material'

const Register = () => {
  return (
    <Box id='register' sx={{pt: '65px', backgroundColor: "rgba(249, 249, 249, 1)"}}>
      <ProgramsCards/>
    </Box>
  )
}

export default Register